import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'angular-web-storage';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(private local:LocalStorageService, private session:SessionStorageService) { }

  setInSession(KEY:string, value:string, expired:number = 0) {
    this.session.set(KEY, value, expired, 's');
  }

  removeSession(KEY:string) {
    this.session.remove(KEY);
  }

  getInSession(KEY:string):string {
    return this.session.get(KEY);
  }

  clearSession() {
    this.session.clear();
  }
}
